import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CookiesService } from 'src/app/services/cookies.service';
import { MenuService } from 'src/app/services/menu/menu.service';
import { InformationsProfilModel } from '../../../../models/profils/informations-profil.model';
import { UtilisateurCourantService } from '../../../../services/utilisateurs/utilisateur-courant.service';

@Component({
  selector: 'app-menu-item-top-notifications',
  templateUrl: './menu-item-top-notifications.component.html',
  styleUrls: ['./menu-item-top-notifications.component.scss'],
})
export class MenuItemTopNotificationsComponent implements OnInit, OnDestroy {
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.menu_topbar_first-level') && !target.closest('.menu_topbar-content')) {
      this.isOpen = false;
    }
  }
  public informationsProfil: InformationsProfilModel;
  public hasNotificationSubscription: Subscription;
  private hasNewNotifications: boolean;
  private subs: Subscription[] = [];
  public isOpen: boolean = false;
  constructor(
    private utilisateurCourantService: UtilisateurCourantService,
    private cookiesService: CookiesService,
    public menuService: MenuService,
  ) {}

  ngOnInit() {
    this.subs.push(
      this.utilisateurCourantService.getInformationsProfilUtilisateur().subscribe(informationsProfil => {
        this.informationsProfil = informationsProfil;
      }),
    );
  }

  ngOnDestroy(): void {
    if (this.hasNotificationSubscription) {
      this.hasNotificationSubscription.unsubscribe();
    }
    this.subs.forEach(it => it.unsubscribe());
  }

  setNewNotificationsAsSeen(): void {
    this.hasNewNotifications = false;
  }

  public reload(){
    this.cookiesService.viderLocalStorageSaufPreferences();
    this.cookiesService.forceReload(this.menuService.version);
  }

  public openMenu(): void {
    this.isOpen = !this.isOpen;
  }
}
